"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertSameShape = exports.TensorFlowModel = void 0;
var tf = __importStar(require("@tensorflow/tfjs-core"));
var tfjs_core_1 = require("@tensorflow/tfjs-core");
var rune_1 = require("@hotg-ai/rune");
/**
 * A TensorFlow model.
 */
var TensorFlowModel = /** @class */ (function () {
    function TensorFlowModel(model) {
        this.model = model;
    }
    TensorFlowModel.prototype.transform = function (inputArray, inputDimensions, outputArray, outputDimensions) {
        var _this = this;
        tf.tidy(function () {
            var inputs = toTensors(inputArray, inputDimensions);
            var result = _this.model.predict(inputs, {});
            var outputs;
            if (Array.isArray(result)) {
                outputs = result;
            }
            else if (result instanceof tfjs_core_1.Tensor) {
                outputs = [result];
            }
            else {
                var names = _this.model.outputs.map(function (info) { return info.name; });
                outputs = namedTensorArray(names, result);
            }
            if (outputs.length != outputArray.length) {
                throw new Error("The model returned ".concat(outputs.length, " tensors, but the Rune expects ").concat(outputArray.length));
            }
            outputs.forEach(function (tensor, i) {
                var out = tensor.dataSync();
                var shape = outputDimensions[i];
                var typedArray = typedArrayFromTFJS(out, shape);
                var bytes = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
                outputArray[i].set(bytes);
            });
        });
    };
    Object.defineProperty(TensorFlowModel.prototype, "inputs", {
        get: function () {
            return this.model.inputs.map(toShape);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TensorFlowModel.prototype, "outputs", {
        get: function () {
            return this.model.outputs.map(toShape);
        },
        enumerable: false,
        configurable: true
    });
    return TensorFlowModel;
}());
exports.TensorFlowModel = TensorFlowModel;
function namedTensorArray(names, result) {
    var outputs = [];
    for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
        var name_1 = names_1[_i];
        if (name_1 in result) {
            outputs.push(result[name_1]);
        }
        else {
            var commaSeparatedNames = Object.keys(result);
            throw new Error("Tried to get the \"".concat(name_1, "\" output, but inference returned \"").concat(JSON.stringify(commaSeparatedNames), "\""));
        }
    }
    return outputs;
}
var TensorFlowToRustDataTypes = {
    float32: ["f32"],
    int32: ["i32", "i16", "i8", "u8"],
};
function assertSameShape(tensor, shape) {
    var actualDimensions = tensor.shape;
    if (actualDimensions.toString() != shape.dimensions.toString()) {
        throw new Error("Expected a ".concat(shape, ", but found a tensor of ").concat(actualDimensions));
    }
    var matchingDataTypes = TensorFlowToRustDataTypes;
    var compatibleShapes = matchingDataTypes[tensor.dtype];
    if (!compatibleShapes) {
        throw new Error("Rune is unable to handle ".concat(tensor.dtype, " tensors"));
    }
    else if (!compatibleShapes.includes(shape.type)) {
        throw new Error("A ".concat(shape.type, " tensor isn't compatible with ").concat(compatibleShapes.join("or")));
    }
}
exports.assertSameShape = assertSameShape;
function toTensors(buffers, shapes) {
    var tensors = [];
    for (var i = 0; i < buffers.length; i++) {
        var buffer = buffers[i];
        var shape = shapes[i];
        var tensor = new rune_1.Tensor(shape, buffer);
        tensors.push(toTensorFlowTensor(tensor));
    }
    return tensors;
}
function toTensorFlowTensor(tensor) {
    var elementType = tensor.elementType, dimensions = tensor.dimensions;
    var dims = __spreadArray([], dimensions, true);
    switch (elementType) {
        case "f32":
            var floats = tensor.asTypedArray(elementType);
            return tf.tensor(floats, dims, "float32");
        // This is kinda annoying because it's just copy/paste, but we
        // can't combine them because TypeScript errors with the following:
        //
        //   The call would have succeeded against this implementation, but
        //   implementation signatures of overloads are not externally
        //   visible.
        case "u8":
            var u8s = tensor.asTypedArray(elementType);
            return tf.tensor(Array.from(u8s), dims, "int32");
        case "u16":
            var u16s = tensor.asTypedArray(elementType);
            return tf.tensor(Array.from(u16s), dims, "int32");
        case "u32":
            var u32s = tensor.asTypedArray(elementType);
            return tf.tensor(Array.from(u32s), dims, "int32");
        case "i8":
            var i8s = tensor.asTypedArray(elementType);
            return tf.tensor(Array.from(i8s), dims, "int32");
        case "i16":
            var i16s = tensor.asTypedArray(elementType);
            return tf.tensor(Array.from(i16s), dims, "int32");
        case "i32":
            var i32s = tensor.asTypedArray(elementType);
            return tf.tensor(Array.from(i32s), dims, "int32");
        default:
            throw new Error("Unable to convert a ".concat(tensor.shape.toString(), " to a tfjs tensor"));
    }
}
/**
 * Convert model tensor information to a Shape that Rune can more easily
 * consume.
 */
function toShape(_a) {
    var dtype = _a.dtype, shape = _a.shape, tfDtype = _a.tfDtype;
    var cleanedShape = [];
    // As a best effort, we try to filter out the dimensions with unknown
    // lengths (null or -1) and fall back to the empty array if no shape was
    // provided at all.
    if (shape) {
        for (var _i = 0, shape_1 = shape; _i < shape_1.length; _i++) {
            var dimension = shape_1[_i];
            if (typeof dimension === "number" && dimension >= 0) {
                cleanedShape.push(dimension);
            }
        }
    }
    return new rune_1.Shape(tfDtype || dtype || "unknown", cleanedShape);
}
/**
 * Convert the array buffer returned by tfjs's tensor.dataSync() into a typed
 * array with the correct type.
 * @param tensorData The raw tensor data.
 * @param shape The shape we expect.
 * @returns
 */
function typedArrayFromTFJS(tensorData, shape) {
    switch (shape.type) {
        case "u8":
            if (tensorData instanceof Int32Array) {
                return new Uint8Array(tensorData);
            }
            break;
        case "i8":
            if (tensorData instanceof Int32Array) {
                return new Int8Array(tensorData);
            }
            break;
        case "u16":
            if (tensorData instanceof Int32Array) {
                return new Uint16Array(tensorData);
            }
            break;
        case "i16":
            if (tensorData instanceof Int32Array) {
                return new Int16Array(tensorData);
            }
            break;
        case "u32":
            throw new Error("TODO: Figure out whether converting a tfjs Int32Array to a tensor of u32s is valid");
        case "i32":
            if (tensorData instanceof Int32Array) {
                return new Int32Array(tensorData);
            }
            break;
        case "f32":
            return tensorData;
    }
    throw new Error("Unable to convert a tfjs tensor of ".concat(tensorData.constructor.name, " to a ").concat(shape.toString()));
}
